import { Button, Typography } from 'antd';
import moment from 'moment';
import React, { useMemo, useState } from 'react';
import { GiAirplaneArrival, GiAirplaneDeparture, GiHouse } from 'react-icons/gi';
import { Link, useParams } from 'react-router-dom';
import Page from '../components/pages/table';
import Item from '../components/category/items/flight_schedule';
import Search from './search';
import { useSelector } from 'react-redux';
import { ExcelExporter } from './excel_button';

export default () => {
    const {direction} = useParams();
    const Icon=useMemo(()=>{
        return direction==='arrival'?GiAirplaneArrival:GiAirplaneDeparture;
    }, [direction])
    const [flights, setFlights]=useState([]);
    const {userdata} = useSelector(state=>state.auth);
    const origin_active= direction==='arrival' || (userdata.level & 0x1ff4) > 0;
    const dest_active= direction==='departure' || (userdata.level & 0x1ff4) > 0;

    const [searchValue, setSearchValue]=useState({flight_date:[moment(), moment().add(1, 'day')], flight_number:'', airline:null});
    const formatedSearchVal=useMemo(()=>{
        const {flight_date, airline, ...others} = searchValue;
        const airports=userdata?.tpis?.filter((row)=>row?.station_type==='airport').map(({station_id})=>station_id);
        const origin = (!origin_active)?airports : searchValue.origin;
        const dest = (!dest_active)?airports : searchValue.dest;
        const [from, to] = flight_date;
        const airline_id=airline?airline._id:undefined;
        return {...others, from:from.format('DD-MMM-YYYY'), to:to.format('DD-MMM-YYYY'), airline_id, origin, dest};
    }, [searchValue, origin_active, dest_active]);
    const uri=`api/v1/flight_schedule/international/${direction}/inquiry`;
    const url=`/flight/schedule/${direction}`;
    
    return (
        <Page 
            url={uri}
            searchValue={formatedSearchVal}
            title={`flight_schedule_${direction}`} 
            icon={Icon} 
            filterValues={['flight_number', 'flight_date_str', 'origin', 'dest']}
            OtherComponent={<ExcelExporter flight_records={flights} direction={direction} />}
            onDataEvent={(data)=>{
                if(!!data && Array.isArray(data)){
                    setFlights(data);
                    const currentTime=moment().unix();
                    const mData=data.map((row, idx)=>{
                        const scheduleTime=direction==='arrival'?row.unixSta:row.unixStd;
                        const diff=Math.abs(currentTime - (scheduleTime || 0));
                        return {...row, number:idx+1, diff};
                    });
                    const sorted=mData.sort((a, b)=>a.diff - b.diff);
                    return sorted;
                }
                return [];
            }}
            searchComponent={
                <Search 
                    onSearchCallback={(value)=>{                        
                        setSearchValue({...value, timestamp:moment().unix()});
                    }} 
                    initValue={searchValue}
                    direction={direction}
                />
            }
            breadcrumbs={
                [
                    {
                        href:'/home',
                        icon:<GiHouse color='white' />,
                        item:'home'
                    },
                    {
                        item:'flight_schedule'
                    },
                    {
                        item:'flight_schedule_'+direction
                    }
                ]
            }
            renderItem={(row, idx)=>row && (<Item row={row} key={idx} direction={direction} url={url}/>)}
        />
    )
}